import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchSuppliers } from '../actions/suppliers'
import Picker from '../components/Picker'
import Suppliers from '../components/Suppliers'
import PubSubManager from '../util/PubSubManager'

class SupplierList extends Component {
  static propTypes = {
    suppliers: PropTypes.array.isRequired,
    isFetching: PropTypes.bool.isRequired,
    lastUpdated: PropTypes.number,
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { dispatch } = this.props
    PubSubManager.subscribe("search_suppliers", this, function(parent, d) {
        console.log("Data is " , d);
        dispatch(fetchSuppliers(d));
    });
    console.log("PubSubManager =", PubSubManager);
    window.PubSubManager = PubSubManager;
  }

  componentWillReceiveProps(nextProps) {
   
  }

  

 
  render() {
    const {  suppliers, isFetching, lastUpdated, error } = this.props;
    const isEmpty = suppliers.length === 0;
    const isError = error != null;
    
    return (
      <div>
        {isError ? <h2>Failed to get suppliers</h2> :
            isEmpty
          ? (isFetching ? <h2>Loading...</h2> : <h3>No suppliers, please do a search or change the criteria.</h3>)
          : <div style={{ opacity: isFetching ? 0.5 : 1 }}>
              <Suppliers suppliers={suppliers} />
            </div>
        }
      </div>
    )
  }
}

const mapStateToProps = props => {
    //properties come from jsx attribute suppliers - <Suppliers suppliers={suppliers} />
    return { 
        suppliers: props.suppliers.suppliers,
        isFetching: props.suppliers.isFetching,
        lastUpdated: props.suppliers.lastUpdated,
        error: props.suppliers.error
      };
}



export default connect(mapStateToProps)(SupplierList)



// WEBPACK FOOTER //
// ./src/containers/SupplierList.js